import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from "react-tooltip";
export const Button = ({ onClick, kind, children, tooltip, disabled }) => {
    const normal = " h-9 bg-slate-500 hover:bg-slate-700 text-white font-bold py-1 px-2 border border-slate-700 rounded";
    const styles = {
        normal_fat: `min-w-[75px] ${normal}`,
        normal: `min-w-[36px] ${normal}`,
        warn: "w-9 h-9 bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2 border border-red-700 rounded",
        error: "w-9 h-9 bg-red-700 hover:bg-red-700 text-white font-bold py-1 px-2 border border-red-700 rounded",
        transparent: "w-9 h-9 bg-transparent hover:bg-slate-100 font-bold py-1 px-2 rounded",
        // disabled: "opacity-50 cursor-not-allowed",
        disabled: "w-9 h-9 bg-slate-500 text-gray-400 font-bold py-1 px-2 border border-slate-700 rounded opacity-50 cursor-not-allowed hover:bg-slate-500"
    };
    const style = (disabled)
        ? styles['disabled']
        : kind
            ? styles[kind]
            : styles.normal;
    const id = Math.random().toString();
    return (_jsxs(_Fragment, { children: [tooltip && (_jsxs(_Fragment, { children: [_jsx(Tooltip, { id: id }), _jsx("button", { onClick: onClick, className: style, "data-tooltip-id": id, "data-tooltip-place": "top", "data-tooltip-content": tooltip, disabled: disabled, children: children })] })), !tooltip && (_jsx("button", { onClick: onClick, className: style, children: children }))] }));
};
